'use client';

import { useCallback, useSyncExternalStore } from 'react';
import { getVoiceAvatarDismissalStore } from './voice-avatar-dismissal-state';

const noSubscription = () => () => {};
const serverSnapshot = () => false;

export function useIdleVoiceAvatarDismissal(userId: string | null) {
  const store =
    typeof document === 'undefined'
      ? null
      : getVoiceAvatarDismissalStore(document);
  const dismissed = useSyncExternalStore(
    store?.subscribe ?? noSubscription,
    () => store?.isDismissed(userId) ?? false,
    serverSnapshot
  );
  const dismiss = useCallback(() => store?.dismiss(userId), [store, userId]);
  return { dismissed, dismiss };
}
